import { CommonModule } from "@angular/common"
import { Component, Injector, Input, OnInit } from "@angular/core"
import { FormsModule, NgControl, ReactiveFormsModule } from "@angular/forms"
import { SelectCode } from "@corporate-tailwind/model"
import { CorpControlTitleComponent } from "../common/corp-control-title/corp-control-title.component";
import { CorpControlCommonComponent } from "../common/corp-control-common/corp-control-common.component";

@Component({
    selector: 'corp-select',
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, CorpControlTitleComponent],
    templateUrl: './corp-select.component.html',
})
export class CorpSelectComponent extends CorpControlCommonComponent implements OnInit {
    @Input('options') options: SelectCode[] = [];
    @Input() compareWith: (a: SelectCode | null, b: SelectCode | null) => boolean = (a, b) => {
        if (!a || !b) return false
        return a.id === b.id || (!!a.code && !!b.code && a.code === b.code)
    };

    constructor(
        private injector: Injector
    ) {
        super()
    }

    ngOnInit(): void {
        const ngControl = this.injector.get(NgControl, null)
        this.setNgControl(ngControl)
    }

    onSelectChange(event: Event): void {
        const selected = this.options.find(
            o => this.compareWith(o, (event.target as HTMLSelectElement).value as any)
        )
        this.value = selected ?? null
        this.onChange(selected)
    }
}
